export enum fileTypes {
  EXCEL = 'xlsx',
  PDF = 'pdf',
}
